import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'

import { useCustomerStore } from './customer-store/store'

interface KidInCustomerPayload {
  kidId: KidInCustomer['id'] | null
}
interface KidInCustomerReturn {
  kid: ComputedRef<KidInCustomer | null>
  name: ComputedRef<KidInCustomer['name']>
}

const getKid = (customerStore: ReturnType<typeof useCustomerStore>, kidId: KidInCustomer['id'] | null): KidInCustomer | null => {
  return customerStore.customer?.kids.find(kid => kid.id === kidId) || null
}
const getKidName = (kid: KidInCustomer | null): string => kid?.name || 'kid'

export const useKidInCustomer = (payload: KidInCustomerPayload): KidInCustomerReturn => {
  const customerStore = useCustomerStore()

  const kid = computed(() => getKid(customerStore, payload.kidId))
  const name = computed(() => getKidName(kid.value))

  return {
    kid,
    name,
  }
}

interface RawKidInCustomerPayload {
  kidId: KidInCustomer['id'] | null
}
interface RawKidInCustomerReturn {
  kid: KidInCustomer | null
  name: KidInCustomer['name']
}

export const useRawKidInCustomer = (payload: RawKidInCustomerPayload): RawKidInCustomerReturn => {
  const customerStore = useCustomerStore()

  const kid = getKid(customerStore, payload.kidId)
  const name = getKidName(kid)

  return {
    kid,
    name,
  }
}
